import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-ink-muted">
                <div className="sp-overline">Loading</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (!user?.is_admin) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="admin-forbidden">
                <div className="text-center px-6">
                    <div className="font-serif text-4xl mb-3">403</div>
                    <div className="text-ink-muted">Admin access required.</div>
                </div>
            </div>
        );
    }
    return children;
}
